(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["EmojiPicker"] = factory(require("react"));
	else
		root["EmojiPicker"] = factory(root["react"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 